module.exports = __webpack_public_path__ + "static/img/94-3.31324d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/94-3.jpg
// module id = JWuo
// module chunks = 0